module.exports = __webpack_public_path__ + "img/622366888.e25286f4.jpg";